import { useEffect } from "react";
import { scrollTop } from "../../components/Helper";

const AboutUs = () => {
	useEffect(() => {
		scrollTop();
	}, []);
	
	return (
		<div className="col-lg-12">
			<div className="card overflow-hidden">
				<div className="card-header p-0 overflow-hidden">
					<div className="about-header">About Us</div>
				</div>
				<div className="card-body bg-white p-1">
					<div className="row">
						<div className="col-12 mb-2">
							<h5 className="bg-light py-2">Started with a commitment for helping Non Resident Indians Across the world A Great Gift to all NRI'S residing in United States.</h5>
							<ul className="about-text">
								<li>First time a real network for all NRIs in all 51 states in the USA</li>
								<li>First time for NRI users Live chat option for Nationwide and Statewide.</li>
								<li>Fully encrypted and secured personal details with confidential login activity</li>
								<li>Business people who want to make more money hurry up improve your traffic by giving ads with us.</li>
								<li>We are not only commercial but kind-hearted too (Fund for Economically poor students in the USA)</li>
								<li>Free classifieds to buy stuff or sell stuff hassle-free with live negotiation options with the buyer and seller.</li>
								<li>Forum with almost 40 kinds of informative topics</li>
								<li>Deshi Pages for all business listings locally in your state and US nationwide.</li>
								<li>Moving out of state don't worry anymore... wherever you go NRIS.com is there for you.</li>
								<li>Save money in travel (First time interstate carpool web services exclusively for NRIs).</li>
								<li>Never go to a bad Restaurant, live ratings with real reviews for all kinds of food places</li>
								<li>Know your daily horoscope right on your home page.</li>
								<li>Know the date and panchangam for that day live.</li>
								<li>Live world, USA, Indian news scrolls.</li>
								<li>Live stock rates.</li>
								<li>Cheap air tickets to anywhere in the world</li>
								<li>Most popular visiting places in your state and overall USA</li>
								<li>Local movies playing in your nearest cities</li>
								<li>Invite anybody for any kind of personal events</li>
								<li>Check for community and religious events</li>
								<li>Check for online webinars and class schedules for all kinds of students in teaching and learning</li>
							</ul>
						</div>
						<div className="col-md-6 p6-1">
							<iframe
								width="100%"
								height="275"
								src="https://www.youtube.com/embed/nah7E8wxwdg?si=OlWCR6AZzQePAXXt"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							></iframe>
						</div>
						<div className="col-md-6 p6-1">
							<iframe
								width="560"
								height="275"
								src="https://www.youtube.com/embed/1paHhQ3QIcM?si=oH91dXG1zPCYUSI5"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							></iframe>
						</div>
						<div className="col-md-6 p6-1">
							<iframe
								width="560"
								height="275"
								src="https://www.youtube.com/embed/NS42izvbZ7k?si=j3uJdvuvpKjeYwAC"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							></iframe>
						</div>
						<div className="col-md-6 p6-1">
							<iframe
								width="560"
								height="275"
								src="https://www.youtube.com/embed/WSL4JidALgo?si=wKHgWkiQTHcRXoOH"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AboutUs;
